import { Autocomplete, TextField } from "@mui/material"

const animalOptions = [
    { id: 1, label: 'Bear' },
    { id: 2, label: 'Wolf' },
    { id: 4, label: 'Cat' },
    { id: 5, label: 'Dog' },
    { id: 6, label: 'Bird' },
    { id: 7, label: 'Elephant' },
];

export const AnimalSelect = ({ id, onChange }) => {

    return (
        <Autocomplete
            id={id}
            options={animalOptions}
            renderInput={params => <TextField {...params} />}
            getOptionLabel={option => option.label}
            onChange={onChange}
            defaultValue={animalOptions[0]}
            // isOptionEqualToValue={(o, v) => o.label === v.label}
        />
    );
}